import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sa-nav-footer',
  templateUrl: './nav-footer.component.html',
  styleUrls: ['./nav-footer.component.scss']
})
export class NavFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
